"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _plantNursery = require("@/services/plant-nursery.service");
var _LotsList = _interopRequireDefault(require("@/flow/plantNursery/components/LotsList.vue"));
var _LotInventorySelector = _interopRequireDefault(require("@/flow/plantNursery/components/LotInventorySelector.vue"));
var _SectionRowInventories = _interopRequireDefault(require("@/flow/plantNursery/components/SectionRowInventories.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'GraftLotPage',
  components: {
    Page: _Page.default,
    LotsList: _LotsList.default,
    LotInventorySelector: _LotInventorySelector.default,
    SectionRowInventories: _SectionRowInventories.default
  },
  data: function data() {
    return {
      selectedLot: null,
      lots: [],
      isLoadingLots: false,
      lotListSearch: '',
      form: this.createDefaultForm(),
      isSubmitting: false,
      varieties: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    page: 'menuItemsPlantsNursery',
    farm: 'GET_FARM'
  })), {}, {
    scionVarieties: function scionVarieties() {
      var items = Array.isArray(this.varieties) ? this.varieties : [];
      return items.filter(function (variety) {
        return (variety === null || variety === void 0 ? void 0 : variety.type) === 'scion';
      });
    },
    senderTotal: function senderTotal() {
      if (!Array.isArray(this.form.senderInventories)) return 0;
      return this.form.senderInventories.reduce(function (sum, inv) {
        return sum + (Number(inv.quantity) || 0);
      }, 0);
    },
    receiverTotal: function receiverTotal() {
      if (!Array.isArray(this.form.receiverInventories)) return 0;
      return this.form.receiverInventories.reduce(function (sum, inv) {
        return sum + (Number(inv.quantity) || 0);
      }, 0);
    },
    quantityMismatch: function quantityMismatch() {
      if (!Array.isArray(this.form.receiverInventories) || this.form.receiverInventories.length === 0) {
        return false;
      }
      return this.senderTotal !== this.receiverTotal;
    }
  }),
  watch: {
    selectedLot: function selectedLot(newLot) {
      if (newLot) {
        this.resetForm();
      }
    }
  },
  mounted: function mounted() {
    this.loadLots();
    this.loadVarieties();
  },
  methods: {
    handleLotsSearch: function handleLotsSearch(searchQuery) {
      this.lotListSearch = searchQuery;
      this.loadLots();
    },
    loadLots: function () {
      var _loadLots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm, filters, _yield$plantNurserySe, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.isLoadingLots = true;
              _context.p = 1;
              filters = {
                page: 1,
                limit: 200,
                type: 'graft',
                farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id,
                plantingOrRegraft: true
              };
              if (this.lotListSearch) {
                filters.code = this.lotListSearch;
              }
              _context.n = 2;
              return _plantNursery.plantNurseryService.fetchLots(filters);
            case 2:
              _yield$plantNurserySe = _context.v;
              response = _yield$plantNurserySe.data;
              this.lots = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.lots = [];
            case 4:
              _context.p = 4;
              this.isLoadingLots = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadLots() {
        return _loadLots.apply(this, arguments);
      }
      return loadLots;
    }(),
    loadVarieties: function () {
      var _loadVarieties = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$farm2, _yield$plantNurserySe2, response, items, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return _plantNursery.plantNurseryService.fetchVarieties({
                page: 1,
                limit: 200,
                farmId: (_this$farm2 = this.farm) === null || _this$farm2 === void 0 ? void 0 : _this$farm2.id
              });
            case 1:
              _yield$plantNurserySe2 = _context2.v;
              response = _yield$plantNurserySe2.data;
              items = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              this.varieties = items;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.varieties = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadVarieties() {
        return _loadVarieties.apply(this, arguments);
      }
      return loadVarieties;
    }(),
    createDefaultForm: function createDefaultForm() {
      return {
        scionId: null,
        mergedAt: new Date(),
        senderInventories: [],
        receiverInventories: []
      };
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
    },
    clearSelection: function clearSelection() {
      this.selectedLot = null;
      this.resetForm();
    },
    handleCancel: function handleCancel() {
      this.resetForm();
      this.$router.push({
        name: 'plant-nursery-lots'
      });
    },
    formatLotType: function formatLotType(type) {
      var types = {
        graft: 'Enxertia',
        grafting: 'Enxertia',
        cut: 'Estaquia',
        cutting: 'Estaquia'
      };
      return types[type] || type || '--';
    },
    formatDate: function formatDate(value) {
      if (!value) return null;
      var date = value instanceof Date ? value : new Date(value);
      return Number.isNaN(date.getTime()) ? null : date.toISOString();
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$selectedLot,
          _this = this;
        var _iterator, _step, _loop, _ret, totalSender, totalReceiver, payload, _error$response, _error$response$data, message, _t3, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if ((_this$selectedLot = this.selectedLot) !== null && _this$selectedLot !== void 0 && _this$selectedLot.id) {
                _context4.n = 1;
                break;
              }
              this.$buefy.toast.open({
                message: 'Lote não encontrado para enxertar.',
                type: 'is-danger'
              });
              return _context4.a(2);
            case 1:
              if (this.form.scionId) {
                _context4.n = 2;
                break;
              }
              this.$buefy.toast.open({
                message: 'Selecione a copa a ser aplicada.',
                type: 'is-danger'
              });
              return _context4.a(2);
            case 2:
              if (!(!Array.isArray(this.form.senderInventories) || this.form.senderInventories.length === 0)) {
                _context4.n = 3;
                break;
              }
              this.$buefy.toast.open({
                message: 'Selecione os inventários para enxertar.',
                type: 'is-danger'
              });
              return _context4.a(2);
            case 3:
              // Validate quantities
              _iterator = _createForOfIteratorHelper(this.form.senderInventories);
              _context4.p = 4;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _this$selectedLot$inv;
                var inv, lotInv, _lotInv$row, _lotInv$row$section, _lotInv$row2;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      inv = _step.value;
                      lotInv = (_this$selectedLot$inv = _this.selectedLot.inventories) === null || _this$selectedLot$inv === void 0 ? void 0 : _this$selectedLot$inv.find(function (i) {
                        return i.id === inv.inventoryId;
                      });
                      if (!(lotInv && inv.quantity > lotInv.quantity)) {
                        _context3.n = 1;
                        break;
                      }
                      _this.$buefy.toast.open({
                        message: "Quantidade para ".concat((_lotInv$row = lotInv.row) === null || _lotInv$row === void 0 ? void 0 : (_lotInv$row$section = _lotInv$row.section) === null || _lotInv$row$section === void 0 ? void 0 : _lotInv$row$section.name, " \u2192 ").concat((_lotInv$row2 = lotInv.row) === null || _lotInv$row2 === void 0 ? void 0 : _lotInv$row2.name, " excede o dispon\xEDvel."),
                        type: 'is-danger'
                      });
                      return _context3.a(2, {
                        v: void 0
                      });
                    case 1:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context4.n = 8;
                break;
              }
              return _context4.d(_regeneratorValues(_loop()), 6);
            case 6:
              _ret = _context4.v;
              if (!_ret) {
                _context4.n = 7;
                break;
              }
              return _context4.a(2, _ret.v);
            case 7:
              _context4.n = 5;
              break;
            case 8:
              _context4.n = 10;
              break;
            case 9:
              _context4.p = 9;
              _t3 = _context4.v;
              _iterator.e(_t3);
            case 10:
              _context4.p = 10;
              _iterator.f();
              return _context4.f(10);
            case 11:
              if (!(Array.isArray(this.form.receiverInventories) && this.form.receiverInventories.length > 0)) {
                _context4.n = 12;
                break;
              }
              totalSender = this.form.senderInventories.reduce(function (sum, inv) {
                return sum + inv.quantity;
              }, 0);
              totalReceiver = this.form.receiverInventories.reduce(function (sum, inv) {
                return sum + inv.quantity;
              }, 0);
              if (!(totalSender !== totalReceiver)) {
                _context4.n = 12;
                break;
              }
              this.$buefy.toast.open({
                message: 'A quantidade total de origem deve ser igual à quantidade total de destino.',
                type: 'is-danger'
              });
              return _context4.a(2);
            case 12:
              payload = {
                scionId: this.form.scionId,
                mergedAt: this.formatDate(this.form.mergedAt),
                senderInventories: this.form.senderInventories
              }; // Only include receiverInventories if provided
              if (Array.isArray(this.form.receiverInventories) && this.form.receiverInventories.length > 0) {
                payload.receiverInventories = this.form.receiverInventories;
              }
              this.isSubmitting = true;
              _context4.p = 13;
              _context4.n = 14;
              return _plantNursery.plantNurseryService.graftLot(this.selectedLot.id, payload);
            case 14:
              this.$buefy.toast.open({
                message: 'Enxertado com sucesso.',
                type: 'is-success'
              });
              this.$router.push({
                name: 'plant-nursery-lots'
              });
              _context4.n = 16;
              break;
            case 15:
              _context4.p = 15;
              _t4 = _context4.v;
              message = (_t4 === null || _t4 === void 0 ? void 0 : (_error$response = _t4.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || 'Não foi possível realizar a enxertia.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 16:
              _context4.p = 16;
              this.isSubmitting = false;
              return _context4.f(16);
            case 17:
              return _context4.a(2);
          }
        }, _callee3, this, [[13, 15, 16, 17], [4, 9, 10, 11]]);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }()
  }
};